import { Puzzle } from "./Game";

export const hardCodedPuzzles: Record<number, Puzzle> = {
}